module.exports = __webpack_public_path__ + "img/travelling_thali.32d69a3e.jpg";